import type { NavSectionProps } from "src/components/nav-section";
import { paths } from "src/routes/paths";

import {
  HiOutlineSquares2X2,
  HiOutlineUsers,
  HiOutlineDocumentText,
  HiOutlineExclamationTriangle,
  HiOutlineMegaphone,
  HiOutlineFlag,
  HiOutlineVideoCamera,
  HiOutlineShieldExclamation,
  HiOutlineSignal,
  HiOutlineShieldCheck,
  HiOutlineStar,
} from "react-icons/hi2";
import { BsPersonExclamation } from "react-icons/bs";

import { TbLock, TbLogout } from "react-icons/tb";

// ----------------------------------------------------------------------

const ICONS = {
  dashboard: <HiOutlineSquares2X2 size={24} />,
  users: <HiOutlineUsers size={24} />,
  reportedUsers: <BsPersonExclamation size={24} />,
  posts: <HiOutlineDocumentText size={24} />,
  reels: <HiOutlineVideoCamera size={24} />,
  reportedPosts: <HiOutlineExclamationTriangle size={24} />,
  reportedReels: <HiOutlineShieldExclamation size={24} />,
  openCall: <HiOutlineMegaphone size={24} />,
  reportedAuditions: <HiOutlineFlag size={24} />,
  live: <HiOutlineSignal size={24} />,
  starFeed: <HiOutlineStar size={24} />,
  features: <HiOutlineShieldCheck size={24} />,
  lock: <TbLock size={24} />,
  logout: <TbLogout size={24} />,
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps["data"] = [
  {
    subheader: "App",
    items: [
      { title: "Dashboard", path: paths.dashboard.root, icon: ICONS.dashboard },
      { title: "Users", path: paths.dashboard.user, icon: ICONS.users },
      {
        title: " Reported Users",
        path: paths.dashboard.reportedUser,
        icon: ICONS.reportedUsers,
      },

      // --- Content Section ---
      { title: "Posts", path: paths.dashboard.post, icon: ICONS.posts },
      {
        title: "Reported Posts",
        path: paths.dashboard.reportedPost,
        icon: ICONS.reportedPosts,
      },

      { title: "Reels", path: paths.dashboard.reel, icon: ICONS.reels },
      {
        title: "Reported Reels",
        path: paths.dashboard.reportedReel,
        icon: ICONS.reportedReels,
      },
      {
        title: "Star Feed",
        path: paths.dashboard.starFeed,
        icon: ICONS.starFeed,
      },
      {
        title: "Open Call",
        path: paths.dashboard.openCall,
        icon: ICONS.openCall,
      },
      {
        title: "Reported Auditions",
        path: paths.dashboard.reportedAudition,
        icon: ICONS.reportedAuditions,
      },
      {
        title: "Live",
        path: paths.dashboard.live,
        icon: ICONS.live,
      },
      {
        title: "Feature Permissions",
        path: paths.dashboard.features,
        icon: ICONS.features,
      },
    ],
  },
  {
    subheader: "Settings",
    items: [
      {
        title: "Change Password",
        path: paths.dashboard.changePassword,
        icon: ICONS.lock,
      },
      { title: "Logout", path: "#", icon: ICONS.logout },
    ],
  },
];
